import React from 'react'
import Link from '../utils/link'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

const AgentHeader = ({ shortBio, team }) => {
  let email = team.acf.email ? team.acf.email : team.teamData.email
  return (
    <section className='agent-header'>
      <Fade bottom distance='40px'>
        <div className='agent-header__inner'>
          <div className='agent-header__left'>
            <h1>{team.title}</h1>
            <h2>{team.acf.jobTitle || team.teamData.position}</h2>
            {shortBio && <div>{parse(shortBio)}</div> }
            <ul>
              <li>
                <Link to='#listings'>
                  <span>Current Listings</span>
                  <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clip-rule="evenodd" d="M17.2693 5.10943L10.6931 9.49237L10.6931 5.86524L0.461595 5.86524L0.461595 4.35347L10.6931 4.35346L10.6931 0.726331L17.2693 5.10943Z" fill="#AAAAAA"/>
                  </svg>
                </Link>
              </li>
              <li>
                <Link to='#contact'>
                  <span>Request an appraisal</span>
                  <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clip-rule="evenodd" d="M17.2693 5.10943L10.6931 9.49237L10.6931 5.86524L0.461595 5.86524L0.461595 4.35347L10.6931 4.35346L10.6931 0.726331L17.2693 5.10943Z" fill="#AAAAAA"/>
                  </svg>
                </Link>
              </li>
              <li>
                <Link to={`mailto:${email}`}>
                  <span>{email}</span>
                  <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clip-rule="evenodd" d="M17.2693 5.10943L10.6931 9.49237L10.6931 5.86524L0.461595 5.86524L0.461595 4.35347L10.6931 4.35346L10.6931 0.726331L17.2693 5.10943Z" fill="#AAAAAA"/>
                  </svg>
                </Link>
              </li>
              <li>
                <Link to='#contact'>
                  <span>Request a callback</span>
                  <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clip-rule="evenodd" d="M17.2693 5.10943L10.6931 9.49237L10.6931 5.86524L0.461595 5.86524L0.461595 4.35347L10.6931 4.35346L10.6931 0.726331L17.2693 5.10943Z" fill="#AAAAAA"/>
                  </svg>
                </Link>
              </li>
            </ul>
          </div>
          <div className='agent-header__right'>
            { team.acf.thumbnailImage && <img src={team.acf.thumbnailImage.localFile.publicURL} alt={team.title} /> }
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default AgentHeader
